import React from "react";
import { Route, Routes } from "react-router-dom";
import { PlansScreen } from "../screens/tenant/Plans.screen";
import { NBAuthGuard } from "./AuthGuard";
const TenantRoutes = () => {
  return /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    path: "plan",
    element: /*#__PURE__*/React.createElement(NBAuthGuard, null, /*#__PURE__*/React.createElement(PlansScreen, null))
  }));
};
export { TenantRoutes };